<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
        <v-flex
        md12>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('product.addNewProduct')}}</v-card-title>
        </v-card>
        <br>
        <v-spacer/>
        <v-tabs left-tabs
                v-model="tab">
          <v-tabs-slider color="amber darken-3"></v-tabs-slider>
          <v-tab
            v-for="(item, index) in items"
            :class="{active: currentTab === index}"
            @click="currentTab = index"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-card flat>
            <div v-show="currentTab === 0">
                 <v-form ref="addProductForm">
                    <v-card-text>
                        <v-container grid-list-md mt-12>
                            <v-layout wrap>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="productName"
                                    :label="$t('product.name')"
                                    :placeholder="$t('product.name')"
                                    :error-messages="productNameErrors"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-text-field
                                    v-model="sku"
                                    :label="$t('product.sku')"
                                    :placeholder="$t('product.sku')"
                                    :error-messages="skuErrors"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-checkbox
                                    v-model="isActiveWeb"
                                    :label="$t('product.web')"
                                ></v-checkbox>
                                <v-checkbox
                                    v-model="isActiveMobile"
                                    :label="$t('product.mobile')"
                                    class="active-web"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="quantity"
                                    numeric
                                    :label="$t('product.quantity')"
                                    :placeholder="$t('product.quantity')"
                                    :error-messages="quantityErrors"
                                    @blur="$v.quantity.$touch()"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <editor
                                    api-key="2ghzmhhubhsfj0nn9sb19mphty0djvenlzasyqg4du0jbfvv"
                                    :init="{ height: 200, menubar: false, }"
                                    v-model="description"
                                    :placeholder="$t('product.description')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <editor
                                    api-key="2ghzmhhubhsfj0nn9sb19mphty0djvenlzasyqg4du0jbfvv"
                                    :init="{ height: 200, menubar: false }"
                                    v-model="specification"
                                    :placeholder="$t('product.specification')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <!-- <v-select
                                    v-model="category"
                                    :items="getCategories"
                                    :label="$t('product.categories')"
                                    :placeholder="$t('product.categories')"
                                    item-text="name"
                                    item-value="id"
                                    class="categories-style"
                                ></v-select> -->
                                 <v-jstree :data="getCategoriesForTree"
                                            show-checkbox
                                            multiple
                                            allow-batch
                                            whole-row
                                            @item-click="treeItemClick"
                                            class="tree-style"></v-jstree>
                            </v-flex>
                            <v-flex xs12 sm6 md8>
                                <span class="icons-style-title">{{ $t('product.specificationIcons') }}</span>
                                <span class="icons-product-wrapper">
                                    <i class="mdi mdi-delete delete delete-sign-product-icon image"  title="delete" @click="removeIcon(0)"></i>
                                    <img class="icon-img-product" id="uploadedIcon1">
                                    <input @change="setIconOne()" class="icons-style" id="produsts-icon-1" type='file' accept="image/*"/>
                                </span>
                                <span class="icons-product-wrapper">
                                    <i class="mdi mdi-delete delete delete-sign-product-icon image"  title="delete" @click="removeIcon(1)"></i>
                                    <img class="icon-img-product" id="uploadedIcon2">
                                    <input @change="setIconTwo()" class="icons-style" id="produsts-icon-2" type='file' accept="image/*"/>
                                </span>
                                <span class="icons-product-wrapper">
                                    <i class="mdi mdi-delete delete delete-sign-product-icon image"  title="delete" @click="removeIcon(2)"></i>
                                    <img class="icon-img-product" id="uploadedIcon3">
                                    <input @change="setIconThree()" class="icons-style" id="produsts-icon-3" type='file' accept="image/*"/>
                                </span>
                            </v-flex>
                            <!-- <v-flex xs12 sm4>
                                <v-select
                                    v-model="subcategory"
                                    :items="getSubcategories"
                                    :label="$t('product.subcategory')"
                                    :placeholder="$t('product.subcategory')"
                                    item-text="name"
                                    item-value="id"
                                    :disabled="isDisabledSubcategory"
                                ></v-select>
                            </v-flex> -->
                            <v-flex xs12 sm6 md6 class="images-wrapper">
                                <v-row class="position-image">
                                    <v-col sm="7">
                                         <span class="image">{{ $t('product.image')}}</span>
                                    </v-col>
                                    <v-col sm="5">
                                        <span class="position">{{ $t('product.position')}}</span>
                                    </v-col>
                                </v-row>
                                <v-row class="position-images">
                                    <v-col sm="7" >
                                        <i class="mdi mdi-delete delete delete-sign-product image"  title="delete" @click="removeImage(0)"></i>
                                        <img class="image-product" id="uploadedImg1">
                                        <input @change="setImage1()" id="image-position-1" type='file' accept="image/*"/>
                                    </v-col>
                                    <v-col sm="5">
                                      <span class="position-number">1</span>
                                    </v-col>
                                </v-row>
                                <v-row class="position-images">
                                    <v-col sm="7" >
                                         <i class="mdi mdi-delete delete delete-sign-product image"  title="delete" @click="removeImage(1)"></i>
                                        <img class="image-product" id="uploadedImg2">
                                        <input @change="setImage2 ()" id="image-position-2" type='file' accept="image/*"/>
                                    </v-col>
                                    <v-col sm="5">
                                      <span class="position-number">2</span>
                                    </v-col>
                                </v-row>
                                 <v-row class="position-images">
                                    <v-col sm="7" >
                                         <i class="mdi mdi-delete delete delete-sign-product image"  title="delete" @click="removeImage(2)"></i>
                                        <img class="image-product" id="uploadedImg3">
                                        <input @change="setImage3()" id="image-position-3" type='file' accept="image/*"/>
                                    </v-col>
                                    <v-col sm="5">
                                      <span class="position-number">3</span>
                                    </v-col>
                                </v-row>
                            </v-flex>
                            <v-flex xs12 sm6 md6 class="images-wrapper">
                                <v-row class="position-image">
                                    <v-col sm="7">
                                         <span class="image">{{ $t('product.image')}}</span>
                                    </v-col>
                                    <v-col sm="5">
                                        <span class="position">{{ $t('product.position')}}</span>
                                    </v-col>
                                </v-row>
                                <v-row class="position-images">
                                    <v-col sm="7" >
                                         <i class="mdi mdi-delete delete delete-sign-product image"  title="delete" @click="removeImage(3)"></i>
                                        <img class="image-product" id="uploadedImg4">
                                        <input @change="setImage4()" id="image-position-4" type='file' accept="image/*"/>
                                    </v-col>
                                    <v-col sm="5">
                                      <span class="position-number">4</span>
                                    </v-col>
                                </v-row>
                                <v-row class="position-images">
                                    <v-col sm="7" >
                                         <i class="mdi mdi-delete delete delete-sign-product image"  title="delete" @click="removeImage(4)"></i>
                                        <img class="image-product" id="uploadedImg5">
                                        <input @change="setImage5()" id="image-position-5" type='file' accept="image/*"/>
                                    </v-col>
                                    <v-col sm="5">
                                      <span class="position-number">5</span>
                                    </v-col>
                                </v-row>
                            </v-flex>
                            <v-flex xs12 sm6 md12 class="tags">
                                <span class="tags-title">{{ $t('product.tags')}}</span>
                                  <div class="tag-input">
                                    <div v-for="(tag) in tags" :key="tag" class="tag-input__tag">
                                    {{ tag.title }}
                                    <!-- <span @click='removeTag(index)' :title="$t('product.removeTag')">x</span> -->
                                    </div>
                                    <input
                                        type="text"
                                        :placeholder="$t('product.enterNewTag')"
                                        class="tag-input__text"
                                        @keydown.enter='addTag'
                                        @keydown.188='addTag' />
                                </div>
                            </v-flex>
                            <v-flex xs12 sm6 md12 class="section-title">{{ $t('product.pricing')}}</v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="price1"
                                    :label="$t('product.price')"
                                    :placeholder="$t('product.price')"
                                    :error-messages="price1Errors"
                                    @blur="$v.price1.$touch()"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-select
                                    v-model="selectedCurrency1"
                                    :items="currency1"
                                    :placeholder="$t('product.currency')"
                                    :label="$t('product.currency')"
                                    return-object
                                    item-text="value"
                                    item-value="id"
                                     :error-messages="currency_1_Errors"
                                    @input="setCurrency_1()"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="discount1"
                                    :label="$t('product.discount')"
                                    :placeholder="$t('product.discount')"
                                    :error-messages="discount1Errors"
                                    :disabled="isDiscount_1_disabled"
                                    @blur="$v.discount1.$touch()"
                                    @input="disableSalePrice1()"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="salePrice1"
                                    :label="$t('product.salePrice')"
                                    :placeholder="$t('product.salePrice')"
                                    :disabled="isSalePrice_1_disabled"
                                    :error-messages="salePrice1Errors"
                                    @blur="$v.salePrice1.$touch()"
                                    @input="disableDiscount1()"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="price2"
                                    :label="$t('product.price2')"
                                    :placeholder="$t('product.price2')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                  <v-select
                                    v-model="selectedCurrency2"
                                    :items="currency2"
                                    :placeholder="$t('product.currency2')"
                                    :label="$t('product.currency2')"
                                    return-object
                                    item-text="value"
                                    item-value="id"
                                    @input="setCurrency_2()"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="discount2"
                                    :disabled="isDiscount_2_disabled"
                                    :label="$t('product.discount')"
                                    :placeholder="$t('product.discount')"
                                    :error-messages="discount2Errors"
                                    @input="disableSalePrice2()"
                                    @blur="$v.discount2.$touch()"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="salePrice2"
                                    :label="$t('product.salePrice')"
                                    :placeholder="$t('product.salePrice')"
                                    :disabled="isSalePrice_2_disabled"
                                    :error-messages="salePrice2Errors"
                                    @input="disableDiscount2()"
                                    @blur="$v.salePrice2.$touch()"

                                />
                            </v-flex>
                            <v-flex xs12 sm6 md12 class="section-title">{{ $t('product.shipping')}}</v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-row>
                                  <v-col sm="6">
                                    <v-flex xs12 sm6 md12>
                                        <v-text-field
                                            v-model="shippingLabel"
                                            :label="$t('product.shippingLabel')"
                                            :placeholder="$t('product.shippingLabel')"
                                        />
                                        </v-flex>
                                    </v-col>
                                </v-row>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="productWidth"
                                    :label="$t('product.width')"
                                    :placeholder="$t('product.width')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                 <v-text-field
                                    v-model="productHeight"
                                    :label="$t('product.height')"
                                    :placeholder="$t('product.height')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="productDepth"
                                    :label="$t('product.depth')"
                                    :placeholder="$t('product.depth')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field
                                    v-model="productWeight"
                                    :label="$t('product.weight')"
                                    :placeholder="$t('product.weight')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md12 class="section-title">{{ $t('product.seo')}}</v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="seoMetaTitle"
                                    :label="$t('product.seoMetaTitle')"
                                    :placeholder="$t('product.seoMetaTitle')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                 <v-text-field
                                    v-model="seoMetaDescription"
                                    :label="$t('product.seoMetaDescription')"
                                    :placeholder="$t('product.seoMetaDescription')"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="seoUrl"
                                    :label="$t('product.seoUrl')"
                                    :placeholder="$t('product.seoUrl')"
                                />
                            </v-flex>
                            </v-layout>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                class="add-new mb-1 mt-8 mr-3" dark
                                @click="cancelProduct()">{{ $t('cancel')}}</v-btn>
                            <v-btn
                                class="add-new mb-1 mt-8 mr-3"
                                dark
                                @click="createProduct()">{{ $t('submit')}}</v-btn>
                        </v-card-actions>
                </v-form>
            </div>
            <div v-show="currentTab === 1">
              <v-card-text>
                <product-personalization
                    @createPersonalization="createProduct()"
                    @personalization="setProductPersonalization"/>
              </v-card-text>
            </div>
          </v-card>
        </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required, numeric } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  import Editor from '@tinymce/tinymce-vue'
  import ProductPersonalizationVue from "@/components/dashboardViews/ProductPersonalization";

  export default {

      data () {
          return {
              personalization: null,
              category_ids: [],
              color: '',
              currentTab: 0,
              tab: null,
              items: [ i18n.t('product.information'), i18n.t('product.personalization')],
              productName: '',
              sku: '',
              isActiveWeb: false,
              isActiveMobile: false,
              quantity: null,
              description: '',
              specification: '',
              category: null,
              subcategory: null,
              price1: null,
              price2: null,
              salePrice1:  null,
              salePrice2:  null,
              isDiscount_1_disabled: false,
              isDiscount_2_disabled: false,
              isSalePrice_1_disabled: false,
              isSalePrice_2_disabled: false,
              discount1:  null,
              discount2:  null,
              productWidth: '',
              productHeight: '',
              productDepth: '',
              productWeight: '',
              seoMetaTitle: '',
              seoMetaDescription: '',
              seoUrl: '',
              isDisabledSubcategory: true,
              tags: [],
              currency1: Object.values(this.getCurrencyOptions()),
              currency2: Object.values(this.getCurrencyOptions()),
              isCurrency_2_disabled: true,
              selectedCurrency1: '',
              selectedCurrency2: '',
              categoryesArray: [],
              subcategoryesArray: [],
              categorySubcategoryArray: [],
              priceArray: [],
              tagIds: [],
              country1: '',
              country2: '',
              images: [],
              spec_images: [],
              shippingLabel: '',
          }

      },
      validations: {
          productName: { required },
          sku: { required },
          quantity: { numeric },
          description: { required },
          price1: { required, numeric },
          discount1: { numeric },
          discount2: { numeric },
          salePrice1: { numeric },
          salePrice2: { numeric },
          selectedCurrency1 : { required }
      },
      computed: {
        ...mapGetters([
            'getAllProducts',
            'getAllCategories',
            // 'getAllProductDesigns',
            // 'getAllFonts',
        ]),
        getCategoriesForTree() {
          const getTree = category => ({
            id: category.id,
            text: category.name,
            opened: true,
            selected: false,
            children: category.subcategories.map(getTree)
          });

          return this.getAllCategories.map(getTree);
        },
        getCategories(){
            return this.getAllCategories;
        },
        getSubcategories(){
            let subcategories = [];
                this.getAllCategories.forEach(el => {
                if(el.id == this.category){
                   subcategories = el.subcategories;
                }
            });
            return subcategories;
        },
        productNameErrors(){
            const errors = [];
                if (!this.$v.productName.$dirty) return errors;
                    !this.$v.productName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        skuErrors(){
            const errors = [];
                if (!this.$v.sku.$dirty) return errors;
                    !this.$v.sku.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        quantityErrors(){
            const errors = [];
                if (!this.$v.quantity.$dirty) return errors;
                    !this.$v.quantity.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        price1Errors(){
            const errors = [];
                if (!this.$v.price1.$dirty) return errors;
                    !this.$v.price1.numeric && errors.push(i18n.tc('fieldValueNumber'));
                    !this.$v.price1.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        discount1Errors(){
            const errors = [];
                if (!this.$v.discount1.$dirty) return errors;
                    !this.$v.discount1.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        discount2Errors(){
            const errors = [];
                if (!this.$v.discount2.$dirty) return errors;
                    !this.$v.discount2.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        salePrice1Errors(){
            const errors = [];
                if (!this.$v.salePrice1.$dirty) return errors;
                    !this.$v.salePrice1.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        salePrice2Errors(){
            const errors = [];
                if (!this.$v.salePrice2.$dirty) return errors;
                    !this.$v.salePrice2.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        currency_1_Errors(){
          const errors = [];
              if (!this.$v.selectedCurrency1.$dirty) return errors;
                  !this.$v.selectedCurrency1.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
        },
      },
      methods: {
        setProductPersonalization(personalization) {
          this.personalization = personalization
        },
        removeImage(index){
          this.images[index] = null
          document.getElementById(`uploadedImg${index+1}`).src = ''
          document.getElementById(`uploadedImg${index+1}`).style.display = 'none'
        //   console.log(index, this.images)
        },
        removeIcon(index) {
          this.spec_images[index] = null
          document.getElementById(`uploadedIcon${index+1}`).src = ''
          document.getElementById(`uploadedIcon${index+1}`).style.display = 'none'
        //   console.log(index, this.spec_images)
        },
        getCurrencyOptions() {
          return {
            EUR: {id: 0, value: 'EUR'},
            RSD: {id: 1, value: 'RSD'},
          }
        },
        disableSalePrice1(){
          this.salePrice1 = null
            // this.discount1 != '' ? this.isSalePrice_1_disabled = true : this.isSalePrice_1_disabled = false;
        },
        disableSalePrice2(){
          this.salePrice2 = null
            // this.discount2 != '' ? this.isSalePrice_2_disabled = true : this.isSalePrice_2_disabled = false;
        },
        disableDiscount1(){
          this.discount1 = null
            // this.salePrice1 != '' ? this.isDiscount_1_disabled = true : this.isDiscount_1_disabled = false;
        },
        disableDiscount2(){
          this.discount2 = null
            // this.salePrice2 != '' ? this.isDiscount_2_disabled = true : this.isDiscount_2_disabled = false;
        },
        treeItemClick(node){
          const getChildrenOfChildren = (category) => {
            if (category.children.length === 0) {
              return `${category.id}`;
            }

            const children = category.children.map(getChildrenOfChildren);

            children.unshift(category.id);

            return children.join(',');
          };

          const categ = getChildrenOfChildren(node.model).split(',').map(
              idStr => parseInt(idStr, 10)
          );

          const uniqueCallback = (value, index, self) => self.indexOf(value) === index;
          const removeCallback = id => !categ.includes(id);

          this.category_ids = (node.model.selected
              ? this.category_ids.concat(categ).filter(uniqueCallback)
              : this.category_ids.filter(removeCallback)).sort((id1, id2) => (id1 - id2));

          this.categoryesArray.push(node.model.id)
        },
      setIconOne(){
          const iconImage = document.getElementById('produsts-icon-1').files[0];
          let output = document.getElementById('uploadedIcon1');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedIcon1').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setIconTwo(){
          const iconImage = document.getElementById('produsts-icon-2').files[0];
          let output = document.getElementById('uploadedIcon2');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedIcon2').style.display = 'block'
              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setIconThree(){
          const iconImage = document.getElementById('produsts-icon-3').files[0];
          let output = document.getElementById('uploadedIcon3');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedIcon3').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setImage1(){
          const iconImage = document.getElementById('image-position-1').files[0];
          let output = document.getElementById('uploadedImg1');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedImg1').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setImage2(){
          const iconImage = document.getElementById('image-position-2').files[0];
          let output = document.getElementById('uploadedImg2');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedImg2').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setImage3(){
          const iconImage = document.getElementById('image-position-3').files[0];
          let output = document.getElementById('uploadedImg3');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedImg3').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setImage4(){
          const iconImage = document.getElementById('image-position-4').files[0];
          let output = document.getElementById('uploadedImg4');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedImg4').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setImage5(){
          const iconImage = document.getElementById('image-position-5').files[0];
          let output = document.getElementById('uploadedImg5');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('uploadedImg5').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
        addTag(e) {
            e.preventDefault();
            let val = e.target.value.trim();
            this.tags.push({ "title": val, "language_identifier": "sr" });
                // this.tags.push(val);
                e.target.value = '';
                // console.log(this.tags[0].title)
                // console.log(this.tags[0].language_identifier)

                this.$store.dispatch('CREATE_TAG', this.tags)
                    .then(() => this.$store.dispatch('LOAD_ALL_TAGS'))
                    .then(() => this.$store.getters.getTagId)
                 let tag = localStorage.getItem('tagId');
                 this.tagIds.push(tag)
        },
        // removeTag(index) {
        //     // this.tags.splice(index, 1);
        //      if (confirm(i18n.t(`areYouSureToDelete`))) {
        //         this.$store.dispatch('DELETE_TAG', index)
        //             .then(() => this.$store.dispatch('LOAD_ALL_TAGS'));
        //     }
        // },
        setCurrency_1(){
          if(this.selectedCurrency1.value === 'RSD'){
            this.country1 = 'RS'
          }
          if(this.selectedCurrency1.value === 'EUR'){
            this.country1 = null
          }

             if (this.selectedCurrency1.value !== this.selectedCurrency2.value) {
               return
             }

             // const price1 = this.price1
             // const discount1 = this.discount1
             // const salePrice1 = this.salePrice1

             if(this.selectedCurrency1.value === 'RSD'){
                this.selectedCurrency2 = {id: 0, value: 'EUR'}
                this.country2 = null
             }
             if(this.selectedCurrency1.value === 'EUR'){
                this.selectedCurrency2 = {id: 1, value: 'RSD'}
                this.country2 = 'RS'
             }

          // this.price1 = this.price2
          // this.discount1 = this.discount2
          // this.salePrice1 = this.salePrice2
          // this.price2 = price1
          // this.discount2 = discount1
          // this.salePrice2 = salePrice1
        },
        setCurrency_2(){
          if(this.selectedCurrency2.value === 'RSD'){
            this.country2 = 'RS'
          }
          if(this.selectedCurrency2.value === 'EUR'){
            this.country2 = null
          }

          if (this.selectedCurrency2.value !== this.selectedCurrency1.value) {
            return
          }
          // const price2 = this.price2
          // const discount2 = this.discount2
          // const salePrice2 = this.salePrice2

            if(this.selectedCurrency2.value === 'RSD'){
                this.selectedCurrency1 = {id: 0, value: 'EUR'}
                this.country1 = null
            }
            if(this.selectedCurrency2.value === 'EUR'){
                this.selectedCurrency1 = {id: 1, value: 'RSD'}
                this.country1 = 'RS'
            }

          // this.price2 = this.price1
          // this.price1 = price2
          // this.discount1 = discount2
          // this.salePrice1 = salePrice2
        },
        // calculateDiscount_1(){
        //    this.isSalePrice_1_disabled = false;
        //    let res = ((this.discount1 / 100) * this.price1).toFixed(2);
        //    this.salePrice1 = res;
        // },
        resetProductsForm(){
            this.$refs.addProductForm.reset();
            this.$v.$reset();
            document.getElementById('produsts-icon-1').value = '';
            document.getElementById('produsts-icon-2').value = '';
            document.getElementById('produsts-icon-3').value = '';
            document.getElementById('image-position-1').value = '';
            document.getElementById('image-position-2').value = '';
            document.getElementById('image-position-3').value = '';
            document.getElementById('image-position-4').value = '';
            document.getElementById('image-position-5').value = '';
        },
        cancelProduct(){
            this.resetProductsForm();
            this.$router.push(`/${i18n.locale}/products`);
        },
        createProduct(){

        for (let i = 1; i <= 3; i++) {
            const icon = document.getElementById(`produsts-icon-${i}`).files[0];
            if (icon) {
              this.spec_images[i-1] = icon;
            }
          }

          for (let i = 1; i <= 5; i++) {
            let file = document.getElementById(`image-position-${i}`).files[0];
            if (file) {
              if (this.images[i-1]) {
                this.images[i-1] = file;
              } else {
                this.images.push(file);
              }
            }
          }

          let formData = new FormData();
          if(this.personalization) {
            this.personalization.printing_image && formData.append('printing_image', this.personalization.printing_image)
            this.personalization.printing_image_height && formData.append('printing_image_height', this.personalization.printing_image_height)
            this.personalization.printing_image_width && formData.append('printing_image_width', this.personalization.printing_image_width)
            this.personalization.printing_area_height && formData.append('printing_area_height', this.personalization.printing_area_height)
            this.personalization.printing_area_width && formData.append('printing_area_width', this.personalization.printing_area_width)
            this.personalization.printing_area_top && formData.append('printing_area_top', this.personalization.printing_area_top)
            this.personalization.printing_area_left && formData.append('printing_area_left', this.personalization.printing_area_left)

            formData.append('enable_personalization', this.personalization.enable_personalization);
            formData.append('engraving_type',  this.personalization.engraving_type ? this.personalization.engraving_type : '');
            formData.append('customer_design_upload_enabled', this.personalization.customer_design_upload_enabled);
            this.personalization.personalization_type.split(',').forEach((type, index) => {
              formData.append(`personalization_type[${index}]`, type);
            });

            this.personalization.variants.forEach((variant, index) => {
              if (variant.id) {
                formData.append(`variants[${index}][id]`, variant.id);
              }
              if(this.urlProductId) {
                formData.append(`variants[${index}][product_id]`, this.urlProductId);
              }
              formData.append(`variants[${index}][title]`, variant.title);
              formData.append(`variants[${index}][group_name]`, variant.group_name);
              formData.append(`variants[${index}][image]`, variant.image);

              variant.prices.forEach((price, pIndex) => {
                formData.append(`variants[${index}][prices][${pIndex}][currency]`, price.currency);
                formData.append(`variants[${index}][prices][${pIndex}][value]`, price.value);
              });
            });

            formData.append('font_ids_enabled',new Blob([JSON.stringify(this.personalization.font_ids_enabled)],{type: 'application/json'}))
            formData.append('design_ids', new Blob([JSON.stringify(this.personalization.design_ids || [])],{type: 'application/json'}))
          }

          formData.append('translations[0][language_identifier]', 'en');
          // formData.append('font_ids_enabled[]', this.selectedFonts);
          // formData.append('designs[]', this.selectedDesigns);

            formData.append('translations[0][language_identifier]', 'en');
          // formData.append('font_ids_enabled[]', this.selectedFonts);
          // formData.append('designs[]', this.selectedDesigns);
              formData.append('sku', this.sku);
              formData.append('enable_website', this.isActiveWeb);
              formData.append('enable_mobile', this.isActiveMobile);

              for (let i = 0; i < 2; i++) {
                if (!this[`price${i+1}`]) {
                  continue
                }
                formData.append(`prices[${i}][value]`, this[`price${i+1}`])
                formData.append(`prices[${i}][currency]`, this[`selectedCurrency${i+1}`].value)

                for (let key of ['country', 'discount', 'salePrice']) {
                  if (this[`${key}${i+1}`]) {
                    formData.append(
                        `prices[${i}][${key.replace(/([a-z])([A-Z])/, '$1_$2').toLowerCase()}]`,
                        this[`${key}${i+1}`]
                    )
                  }
                }

              }
              if(this.quantity) {
                formData.append('stock_level', this.quantity)
              }
              for (let j = 0; j < this.category_ids.length; j++) {
                  formData.append('category_ids[]', this.category_ids[j]);
              }
              for (let i = 0; i < this.tagIds.length; i++) {
                  formData.append('tag_ids[]', this.tagIds[i]);
              }
              formData.append('shipping_width', this.productWidth);
              formData.append('shipping_height', this.productHeight);
              formData.append('shipping_depth', this.productDepth);
              formData.append('shipping_weight', this.productWeight);
              formData.append('shipping_note', this.shippingLabel);

              for (let i = 0; i < this.spec_images.length; i++) {
                formData.append(`spec_images[${i}]`, this.spec_images[i]);
              }

              const images = this.images.filter(image => image);
              for (let i = 0; i < images.length; i++) {
                formData.append(`images[${i}]`, images[i]);
              }

              formData.append('translations[0][title]', this.productName);

              if(this.description.includes('font-family')) {
                let split0 = this.description.split('font-family')[0] + 'font-family:'
                let split1 = this.description.split('font-family')[1]
                let oldFont = split1.substring(0, split1.indexOf('font-size'))
                let newSplit1 = split1.replace(oldFont, ' noto-sans; ')
                formData.append('translations[0][description]',  split0 + newSplit1);
                formData.append('translations[0][short_description]', split0 + newSplit1);
              } else if(!this.description.includes('font-family') && this.description.includes('<p>')) {
                let addFont = this.description.slice(0, 2)
                + ' style="font-family: noto-sans;" '
                + this.description.slice(2);
                formData.append('translations[0][description]',  addFont);
                formData.append('translations[0][short_description]', addFont);
              } else {
                formData.append('translations[0][description]',  this.description);
                formData.append('translations[0][short_description]', this.description);
              }

              if(this.specification.includes('font-family')) {
                let split0 = this.specification.split('font-family')[0] + 'font-family:'
                let split1 = this.specification.split('font-family')[1]
                let oldFont = split1.substring(0, split1.indexOf('font-size'))
                let newSplit1 = split1.replace(oldFont, ' noto-sans; ')
                formData.append('translations[0][specification]',  split0 + newSplit1);
              }else if(!this.specification.includes('font-family') && this.specification.includes('<p>')) {
                let addFont = this.specification.slice(0, 2)
                + ' style="font-family: noto-sans;" '
                + this.specification.slice(2);
                formData.append('translations[0][specification]',  addFont);
              } else {
                formData.append('translations[0][specification]',  this.specification);
              }

              formData.append('translations[0][meta_title]', this.seoMetaTitle)
              formData.append('translations[0][meta_description]', this.seoMetaDescription)
              formData.append('translations[0][meta_description]', this.seoMetaDescription)
              formData.append('translations[0][meta_url]', this.seoUrl);
              formData.append('translations[0][language_identifier]', 'sr');

            if(this.category_ids.length == 0){
                alert(i18n.t(`pleaseSelectCategory`));
            }

            if(this.$v.productName.$invalid || this.$v.sku.$invalid || this.$v.price1.$invalid
                   || this.$v.selectedCurrency1.$invalid){
                this.$v.$touch();
                return;
            } else {
                this.$store.dispatch('CREATE_PRODUCT', formData)
                    .then(() => this.$store.dispatch('LOAD_ALL_PRODUCTS'))
            }
        },
      },
      components: {
         'editor': Editor,
        'product-personalization': ProductPersonalizationVue
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
          this.$store.dispatch('LOAD_ALL_CATEGORIES');
          this.$store.dispatch('LOAD_ALL_TAGS');
          this.$store.dispatch('LOAD_ALL_FONTS');
          this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS');
      },
      mounted() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
          this.$store.dispatch('LOAD_ALL_CATEGORIES');
          this.$store.dispatch('LOAD_ALL_TAGS');
          this.$store.dispatch('LOAD_ALL_FONTS');
          this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS');
      },
  }
</script>

<style lang="less">
    .active-web{
        margin-top: -20px !important;
    }
    .categories-style{
        margin-top: 15px !important;
    }
    .icons-style-title{
        margin-top: 30px;
        margin-bottom: 12px;
        display: block;
        color: #4f4f4f;
        font-size: 16px;
    }
    .icons-style{
        margin-bottom: 5px;
    }
    .images-wrapper{
        margin-top: 12px;
        color: #4f4f4f;
        font-size: 16px;

        .position-images{
            border: 1px solid #eee;
            border-radius: 5px;
            margin-bottom: 1px;
            margin-right: 10px;
        }
        .position-number{
            display: inline-block;
            position: relative;
            left: 10%;
        }
    }
    .tree-style{
        margin-top: 35px;
    }

</style>
